import { store } from "../lib/store";
import axios from "axios";
import { globalNavigate } from "../utilities/navigation";

import { refreshToken } from "../lib/features/user-auth/userAuth.thunk";
import { jwtDecode } from "jwt-decode";

export const axiosPublic = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_URL,
  headers: {
    "content-type": "application/json",
  },
  // withCredentials: true,
});
axiosPublic.interceptors.request.use(async (config) => {
  // Handle token here ...
  return config;
});
axiosPublic.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response;
    }
    return response;
  },
  (error) => {
    if (error.response.data.status === 500) {
      return globalNavigate("/error/server-error");
    }

    return Promise.reject(error);
  }
);

export const axiosPrivate = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_URL,
});
let requestRefreshToken: any = null;

axiosPrivate.interceptors.request.use(
  async (config) => {
    const user = store?.getState()?.userAuth?.data;
    const currentDate = new Date();

    if (user?.token) {
      const decodedToken: { exp: number } = jwtDecode(user.token);

      // Nếu token hết hạn → refresh
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        requestRefreshToken =
          requestRefreshToken ?? store.dispatch(refreshToken());
        await requestRefreshToken;
        requestRefreshToken = null;

        // Lấy lại token mới sau khi refresh
        const newUser = store?.getState()?.userAuth?.data;
        config.headers["authorization"] = `Bearer ${newUser?.token}`;
      } else {
        // Token còn hạn thì gắn luôn
        config.headers["authorization"] = `Bearer ${user.token}`;
      }
    }

    return config;
  },
  (error) => {
    if (error?.response?.data?.status === 500) {
      globalNavigate("/error/server-error");
    }
    return Promise.reject(error);
  }
);